var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLogoarmoniaBianco = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 33.866,
    viewBox: "0 0 276 67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1656",
    "data-name": "Raggruppa 1656",
    transform: "translate(-1212 -643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1634",
    "data-name": "Raggruppa 1634",
    transform: "translate(1212.031 654.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1598",
    "data-name": "Rettangolo 1598",
    width: 58,
    height: 14,
    rx: 2,
    transform: "translate(-0.031 20.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1599",
    "data-name": "Rettangolo 1599",
    width: 68,
    height: 16,
    rx: 2,
    transform: "translate(8.969 39.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1602",
    "data-name": "Rettangolo 1602",
    width: 68,
    height: 16,
    rx: 2,
    transform: "translate(8.969 -0.141)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Armon\\xECa",
    transform: "translate(1303 687)",
    fill: "#fff",
    fontSize: 46,
    fontFamily: "TIMSans-Bold, TIM Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Armon\xECa")), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1629",
    "data-name": "Raggruppa 1629",
    transform: "translate(1302.802 693.708)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2774",
    "data-name": "Tracciato 2774",
    d: "M-17.539,858.568a1.779,1.779,0,0,1,.076.585q-1.306,5.94-2.638,11.874c-.208.933-.411,1.867-.625,2.8-.194.846-.438,1.031-1.319,1.031h-2.79c-.871,0-1.131-.187-1.327-1.031-.447-1.922-.877-3.848-1.314-5.772-.273-1.2-.542-2.406-.823-3.607a1.318,1.318,0,0,0-.187-.326c-.073.1-.187.192-.212.3q-1.04,4.6-2.063,9.206a4.762,4.762,0,0,1-.142.536.937.937,0,0,1-.976.695c-1.085-.011-2.17,0-3.254,0-.659,0-.93-.188-1.086-.84-.3-1.229-.561-2.465-.838-3.7q-1.243-5.527-2.476-11.057a2.514,2.514,0,0,1,.042-.692h3.721a2.89,2.89,0,0,1,.318.682c.641,3.627,1.264,7.257,1.9,10.885a1.251,1.251,0,0,0,.2.356,1.439,1.439,0,0,0,.205-.359q1.177-5.161,2.337-10.325a1.49,1.49,0,0,1,.9-1.237h3.07a1.373,1.373,0,0,1,.87,1.153c.065.364.159.723.241,1.084q1.043,4.626,2.089,9.251a3.545,3.545,0,0,0,.172.46l.139-.012a3.009,3.009,0,0,0,.112-.368c.636-3.631,1.264-7.262,1.91-10.891a2.776,2.776,0,0,1,.327-.677Z",
    transform: "translate(64.61 -858.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2775",
    "data-name": "Tracciato 2775",
    d: "M-162.147,858.568a2.681,2.681,0,0,1,.206.71q.018,6.9.01,13.794c0,.416.013.833.025,1.249.01.369-.157.526-.536.516-.914-.024-1.828-.04-2.742-.033a1.653,1.653,0,0,1-1.5-1c-.851-1.5-1.684-3.015-2.523-4.524q-1.45-2.607-2.9-5.215c-.052-.093-.1-.189-.146-.283l-.193.083c-.017.243-.049.486-.049.729q0,4.722.006,9.443c0,.793-.048.813-.853.782-.742-.028-1.487-.013-2.229.011-.37.012-.528-.088-.527-.489.01-5.092.005-10.184.014-15.276a1.7,1.7,0,0,1,.165-.5h1.116c.709.022,1.42.09,2.125.053a1.821,1.821,0,0,1,1.847,1.05q1.447,2.658,2.91,5.307.993,1.8,2,3.593c.05.088.171.137.258.2a1.15,1.15,0,0,0,.118-.319c.013-.214-.018-.43-.017-.646.009-2.852.023-5.7.027-8.556,0-.612-.01-.611.6-.624.771-.015,1.541-.042,2.311-.063Z",
    transform: "translate(184.194 -858.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2776",
    "data-name": "Tracciato 2776",
    d: "M167.86,858.568a2.322,2.322,0,0,1,.124.527q0,7.686-.019,15.372c0,.091-.014.182-.026.327-.167.013-.329.036-.491.036-.915,0-1.83-.023-2.743.012-.426.016-.555-.148-.529-.527.005-.077,0-.154,0-.232q0-7.408.01-14.817a2.383,2.383,0,0,1,.233-.7Z",
    transform: "translate(-113.812 -858.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2777",
    "data-name": "Tracciato 2777",
    d: "M-237.69,858.568a1.573,1.573,0,0,1,.179.49q.014,7.654.012,15.307c0,.3-.082.461-.414.458-.99-.009-1.98,0-2.97-.009a1.646,1.646,0,0,1-.435-.131V858.568Z",
    transform: "translate(241.318 -858.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2778",
    "data-name": "Tracciato 2778",
    d: "M234.517,858.568c-.139.925-.269,1.851-.431,2.771-.02.111-.207.235-.339.272a2.082,2.082,0,0,1-.554.021c-3.87,0-7.741.007-11.611,0-.831,0-.64.094-.8-.668-.127-.587-.251-1.174-.348-1.767a2.728,2.728,0,0,1,.041-.626Z",
    transform: "translate(-163.074 -858.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2779",
    "data-name": "Tracciato 2779",
    d: "M265.337,933.6v6.854h-3.744q0-1.123,0-2.243c0-1.419,0-2.838,0-4.256,0-.221,0-.4.3-.405,1.1,0,2.2-.01,3.3-.013A.538.538,0,0,1,265.337,933.6Z",
    transform: "translate(-199.13 -924.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2780",
    "data-name": "Tracciato 2780",
    d: "M241.362,899.169l-.592-2.971c.152-.016.225-.03.3-.03q4.226-.006,8.452-.014c.307,0,.428.089.361.408a19.445,19.445,0,0,0-.387,2.041c-.052.508-.291.577-.723.574-2.2-.015-4.4-.007-6.595-.007Z",
    transform: "translate(-180.897 -891.486)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoarmoniaBianco, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logoarmonia_bianco.a233c1e9.svg";
export { ForwardRef as ReactComponent };